import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, regionsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, regionsActions);

export default slice.reducer;
